<!-- 提交按钮 -->
<template>
  <div class="i-button-view">
    <div class="i-button" @click="clickBtn">
      {{text}}
    </div>
  </div>
</template>

<script>
// 这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
// 例如：import 《组件名称》 from '《组件路径》';

export default {
  // import引入的组件需要注入到对象中才能使用
  components: {},
  props: {
    text: {
      type: String,
      default: ''
    }
  },
  data () {
    // 这里存放数据
    return {}
  },
  // 监听属性 类似于data概念
  computed: {},
  // 监控data中的数据变化
  watch: {},
  // 方法集合
  methods: {
    clickBtn () {
      this.$emit('clickBtn');
    }
  }
}
</script>
 <style lang="scss">
.i-button-view {
  /* width: 100%; */
  text-align: center;
  padding: 0px 30px;
}
.i-button {
  border-radius: 5px;
  /* max-width:315px; */
  height: 44px;
  color: #ffffff;
  background: var(--bgcolor);
  font-size: 17px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 200;
  letter-spacing: 3px;
  line-height: 44px;
  text-align: center;
}
</style>
